import { isEmpty } from 'lodash';

const mapObjectKeys = (
  object: Record<string, any>,
  parent: null | string = null,
): Record<string, any> =>
  Object.assign(
    {},
    ...Object.entries(object).map(([k, v]) => ({
      [k]: {
        ...Object.assign(
          {},
          ...v.map((vv: Record<string, any> | string) => {
            switch (typeof vv) {
              case 'object':
                return mapObjectKeys(
                  vv,
                  `${!isEmpty(parent) ? `${parent}_` : ''}${k}` as string,
                );
              case 'string':
              default:
                return {
                  [vv]: `${!isEmpty(parent) ? `${parent}_` : ''}${k}_${vv}`,
                };
            }
          }),
        ),
      },
    })),
  );

export default mapObjectKeys;
